import { useState } from 'react';
import './App.css';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import DashboardHome from './components/DashboardHome';

import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import LoginPage from './components/auth/LoginPage';
import ForgotPasswordPage from './components/auth/ForgotPasswordPage';
import OtpPage from './components/auth/OtpPage';

import { getLang } from './i18n';
import LawsPage from './components/laws/LawsPage';
import AddLawPage from './components/laws/AddLawPage';
import UserManagementPage from './components/superadmin/UserManagementPage';
import UserProfilePage from './components/superadmin/UserProfilePage';
import ApiDocsCenter from "./components/ApiDocsCenter";
import LegalConsultationsPage from './components/Consultations/LegalConsultationsPage';
import ConsultationReplyPage from './components/Consultations/ConsultationReplyPage';
import SupportPage from './components/SupportPage';
import SupportTicketPage from './components/SupportTicketPage';
import NotificationsPage from './components/NotificationsPage';
import ArticlesPage from './components/ArticlesPage';
import AddArticlePage from './components/AddArticlePage';
import CommunityPage from './components/CommunityPage';
import ReportsPage from './components/ReportsPage';
import AddUserPage from './components/superadmin/AddUserPage';
import ViewLawPage from './components/laws/ViewLawPage';
import SettingsPage from './components/SettingsPage';
import ViewBlogPage from './components/blog/ViewBlogPage';
import PrivacyPolicy from './components/landing/PrivacyPolicy';

function RequireAuth({ children }) {
  const token = localStorage.getItem('access_token');
  if (!token) {
    return <Navigate to="/auth/login" replace />;
  }
  return children;
}

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(
    window.innerWidth >= 768 // Open sidebar on larger screens
      ? true
      : false
  );

  const handleSidebarToggle = () => setSidebarOpen((open) => !open);

  const lang = getLang();
  const isRTL = lang === "ar";
  const sidebarMargin = isRTL
    ? (sidebarOpen ? 'mr-16 md:mr-64' : 'mr-16')
    : (sidebarOpen ? 'ml-16 md:ml-64' : 'ml-16');
  return (
   
      <div className="min-h-screen transition-all duration-300 bg-gray-100 dark:bg-gray-950"
    
        lang={lang}
     >
        <Routes>
          <Route
            path="/auth/login"
            element={
              <main className="flex-1 p-0 bg-gray-100">
                <LoginPage />
              </main>
            }
          />
             <Route
            path="*"
            element={
               <RequireAuth>
                <>
                  <Sidebar open={sidebarOpen} onToggle={handleSidebarToggle} />
                    <div
                    className={`flex flex-col bg-white transition-all duration-300 ${sidebarMargin}`}
                  >

                
                   <main className="flex-1 p-0">
                      <Routes>
                        <Route path="admin/" element={<DashboardHome />} />
                        <Route path="/admin/laws/" element={<LawsPage />} />
                        <Route path="/admin/legal-consultations/" element={<LegalConsultationsPage />} />
                          <Route path="/admin/legal-consultations/reply/:id" element={<ConsultationReplyPage />} />

                         <Route path="/admin/laws/new" element={<AddLawPage />} />
                         <Route path="/admin/laws/:id" element={<ViewLawPage />} />
                        <Route path="/admin/users" element={<UserManagementPage />} />

                        <Route path="/admin/users/:id/edit" element={<UserProfilePage />} />
                        <Route path="/admin/users/new" element={<AddUserPage />} />
                        <Route path="/admin/support" element={<SupportPage />} />
                        <Route path="/admin/support/ticket" element={<SupportTicketPage />} />
                        <Route path="/admin/notifications" element={<NotificationsPage />} />
                        <Route path="/admin/blog" element={<ArticlesPage />} />
                        <Route path="/admin/blog/new" element={<AddArticlePage />} />
                        <Route path="/admin/blog/:uuid" element={<ViewBlogPage />} />
                        <Route path="/admin/community" element={<CommunityPage />} />
                        <Route path="/admin/reports" element={<ReportsPage />} />
                        <Route path="/admin/settings" element={<SettingsPage />} />
                        </Routes>
                        </main>
                          </div>
                  </>  
                  </RequireAuth>
                  }
                  />
            <Route path="/auth/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/auth/otp" element={<OtpPage />} />
            <Route path="/" element={<PrivacyPolicy />} />
          {/* <Route
            path="/auth/register"
            element={
              <main className="flex-1 p-0 bg-gray-100">
                <RegisterPage />
              </main>
            }
          />
          <Route path="/" element={<LandingPage />} />
          <Route
            path="*"
            element={
              // <RequireAuth>
                <>
                  <Sidebar open={sidebarOpen} onToggle={handleSidebarToggle} />
                  <div
                    className={`flex flex-col bg-gray-100 dark:bg-gray-900 transition-all duration-300 ${sidebarMargin}`}
                  >
                    <Header onSidebarToggle={handleSidebarToggle} sidebarOpen={sidebarOpen} />
                    <main className="flex-1 p-6">
                      <Routes>
                        <Route path="admin/" element={<DashboardHome />} />
                        <Route path="/admin/session" element={<SessionStatus />} />
                        <Route path="/admin/chat" element={
                          <ChatPage
                            onSidebarToggle={handleSidebarToggle}
                            sidebarOpen={sidebarOpen}
                          />
                        } />
                        <Route path="/admin/auto-reply" element={<AutoReplyPage />} />
                        <Route path="/admin/profile" element={<ProfilePage />} />
                        <Route path="/admin/send-message" element={<SendMessagePage />} />
                        <Route path="/admin/client" element={<ClientPage />} />
                        <Route path="/admin/groups" element={<GroupPage />} />
                        {/* <Route path="/payment" element={<PaymentPage />} /> 
                        <Route path="/admin/users" element={<UserManagementPage />} />
                        {/* <Route path="/api-docs" element={<ApiDocsCenter />} /> 
                    
                      </Routes>
                    </main>
                  </div>
                </>
              // </RequireAuth>
            
          />
           <Route path="*" element={<NotFoundPage />} /> */}
        </Routes>
      </div>

  );
}

export default App;
